namespace TabAurous.OMS {
    export interface SettingsForm {
        Name: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        Value: Serenity.StringEditor;
        Type: Serenity.StringEditor;
    }

    export class SettingsForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.Settings';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SettingsForm.init)  {
                SettingsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(SettingsForm, [
                    'Name', w0,
                    'Description', w0,
                    'Value', w0,
                    'Type', w0
                ]);
            }
        }
    }
}
